module.exports = __webpack_public_path__ + "static/img/eq1.3ad528d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/eq1.png
// module id = q6V5
// module chunks = 0